import styled from 'styled-components';
import { themeGet, color } from '@magalu/stereo-ui-styles';
import { space, typography } from 'styled-system';
import { Link as LinkComp, Input, Button } from '../../atoms';
const Form = styled.form``;
Form.Link = styled(LinkComp).attrs(props => Object.assign({
  color: 'text.lightest'
}, props))`
  ${color}
`;
Form.Header = styled.div.attrs(props => Object.assign({
  color: 'text.lightest',
  fontSize: 0
}, props))`
  display: flex;
  align-items: center;

  svg {
    margin-right: ${themeGet('space.1')}px;
  }

  ${Form.Link} {
    color: ${themeGet('colors.lightBlue')};
    ${typography}
  }

  ${color};
`;
Form.Title = styled.h2.attrs(props => Object.assign({
  fontSize: 2,
  fontWeight: 'medium',
  color: 'text.lightest'
}, props))`
  ${color}
  ${typography}
`;
Form.InputWrapper = styled.div.attrs(props => Object.assign({
  p: '1'
}, props))`
  display: flex;
  align-items: center;
  ${space}
`;
Form.Input = styled(Input).attrs(props => Object.assign({
  mr: '2'
}, props))`
  ${space}
`;
Form.SubmitBtn = styled(Button).attrs(props => Object.assign({
  color: 'secondary',
  size: 'small',
  m: '10px 0'
}, props))``;
export { Form };